import { render } from "./SwitchBtn.vue?vue&type=template&id=4a60f5d6"
import script from "./SwitchBtn.vue?vue&type=script&lang=js"
export * from "./SwitchBtn.vue?vue&type=script&lang=js"

import "./SwitchBtn.vue?vue&type=style&index=0&id=4a60f5d6&lang=css"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__